module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-router"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("回首页")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/bookrack"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("我的书架")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("登录")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/register"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("注册")])])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("回顶部")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-info"
  }, [_vm._v("\n      版权所有 北京恺兴文化传媒有限公司\n      "), _c('br'), _vm._v("\n      京ICP备11033518号\n      "), _c('br'), _vm._v("\n      京网文（2016）1179-149号\n      "), _c('br'), _vm._v("\n      京ICP证111027号\n      "), _c('br'), _vm._v("\n      © 2013-2016 chuangbie.com, all rights reserved\n      "), _c('br'), _vm._v("\n      客服 4008884032 QQ:613762569\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-14cf91c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 179
// module chunks = 1